import { computed, effect, Injectable, signal } from '@angular/core';

import { ThemeUtilsService } from '@core/theme-logic';
import {
  RECRUITEE_THEME_DEFAULT,
  RECRUITEE_THEME_LS_KEY,
  SupportedThemesT,
} from '@core/theme-util';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly theme = signal<SupportedThemesT>(this.getInitialTheme());

  public readonly isDarkMode = computed(() => this.theme() === 'dark');
  public readonly currentTheme = this.theme.asReadonly();

  constructor() {
    // Apply theme to DOM whenever it changes
    effect(() => {
      const theme = this.theme();
      ThemeUtilsService.setThemeHTMLData(theme);
      this.persistTheme(theme);
    });

    // Apply initial theme immediately
    ThemeUtilsService.setThemeHTMLData(this.theme());
  }

  public toggleTheme(): void {
    this.theme.update(current => (current === 'light' ? 'dark' : 'light'));
  }

  public setTheme(theme: SupportedThemesT): void {
    this.theme.set(theme);
  }

  private getInitialTheme(): SupportedThemesT {
    const stored = localStorage.getItem(RECRUITEE_THEME_LS_KEY);
    if (stored === 'dark' || stored === 'light') {
      return stored;
    }
    return <SupportedThemesT>RECRUITEE_THEME_DEFAULT;
  }

  private persistTheme(theme: SupportedThemesT): void {
    localStorage.setItem(RECRUITEE_THEME_LS_KEY, theme);
  }
}
